/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateXeroOauthTokenSwapInput = {|
  verifier?: ?string,
  tmpInvoiceId?: ?string,
  install?: ?boolean,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type createXeroOauthTokenKeySwapMutationVariables = {|
  input: CreateXeroOauthTokenSwapInput
|};
export type createXeroOauthTokenKeySwapMutationResponse = {|
  +createXeroOauthTokenSwap: ?{|
    +key: ?string
  |}
|};
export type createXeroOauthTokenKeySwapMutation = {|
  variables: createXeroOauthTokenKeySwapMutationVariables,
  response: createXeroOauthTokenKeySwapMutationResponse,
|};
*/


/*
mutation createXeroOauthTokenKeySwapMutation(
  $input: CreateXeroOauthTokenSwapInput!
) {
  createXeroOauthTokenSwap(input: $input) {
    key
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateXeroOauthTokenSwapInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateXeroOauthTokenSwapPayload",
    "kind": "LinkedField",
    "name": "createXeroOauthTokenSwap",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createXeroOauthTokenKeySwapMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createXeroOauthTokenKeySwapMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createXeroOauthTokenKeySwapMutation",
    "operationKind": "mutation",
    "text": "mutation createXeroOauthTokenKeySwapMutation(\n  $input: CreateXeroOauthTokenSwapInput!\n) {\n  createXeroOauthTokenSwap(input: $input) {\n    key\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '179761369ac4ec0a4bec36599608de78';

module.exports = node;
